import { debounce } from 'lodash-es';
import { createProvider } from '@frontend/store';
import { LocationPickerSearchFilters } from './types';

export interface LocationPicker {
  isSearchMode: boolean;
  isPrivilegedPicker?: boolean;
  isSimpleView?: boolean;
  hasSingleOrganization: boolean;
  hasSingleLocationGroup: boolean;
  setIsSearchMode: (isSearchMode: boolean) => void;
  activeSearchFilter: LocationPickerSearchFilters;
  setActiveSearchFilter: (searchFilter: LocationPickerSearchFilters) => void;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  debouncedSearchTerm: string;
  setDebouncedSearchTerm: (debouncedSearchTerm: string) => void;
  inFlightGroupId: string;
  setInFlightGroupId: (inFlightGroupId: string) => void;
  inFlightLocationIds: string[];
  setInFlightLocationIds: (inFlightLocationIds: string[]) => void;
  inFlightOrganizationId: string;
  setInFlightOrganizationId: (inFlightOrganizationId: string) => void;
  organizationViewId: string;
  setOrganizationViewId: (organizationViewId: string) => void;
  groupViewId: string | null;
  setGroupViewId: (groupViewId: string | null) => void;
  resetSearch: () => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const {
  Provider: LocationPickerProvider,
  useStore: useLocationPicker,
  useNonReactiveStore: useLocationPickerStore,
} = createProvider<LocationPicker>()((set, get) => ({
  isSearchMode: false,
  setIsSearchMode: (isSearchMode) => {
    set({ isSearchMode });
    if (!isSearchMode) {
      set({ activeSearchFilter: 'locations' });
    }
  },
  activeSearchFilter: 'locations',
  isPrivilegedPicker: false,
  hasSingleOrganization: false,
  hasSingleLocationGroup: false,
  setActiveSearchFilter: (activeSearchFilter) => set({ activeSearchFilter }),
  organizationViewId: '',
  setOrganizationViewId: (organizationViewId) => set({ organizationViewId }),
  searchTerm: '',
  isSimpleView: false,
  setSearchTerm: (searchTerm) => {
    set({ searchTerm, isLoading: true });
    if (searchTerm.length === 0) {
      set({ isLoading: false, debouncedSearchTerm: '' });
      return;
    }
    get().setDebouncedSearchTerm(searchTerm);
  },
  debouncedSearchTerm: '',
  setDebouncedSearchTerm: debounce((debouncedSearchTerm) => set({ debouncedSearchTerm }), 500),
  inFlightGroupId: '',
  setInFlightGroupId: (inFlightGroupId) => set({ inFlightGroupId, groupViewId: inFlightGroupId }),
  inFlightLocationIds: [],
  setInFlightLocationIds: (inFlightLocationIds) => set({ inFlightLocationIds }),
  inFlightOrganizationId: '',
  setInFlightOrganizationId: (inFlightOrganizationId) => set({ inFlightOrganizationId }),
  groupViewId: null,
  setGroupViewId: (groupViewId) => set({ groupViewId }),
  resetSearch: () => {
    set({ searchTerm: '', debouncedSearchTerm: '' });
  },
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
}));
